import { ReactNode } from 'react';
import { DirectionProvider } from '@radix-ui/react-direction';
import { useLanguage } from '../contexts/LanguageContext';

interface DirectionProviderWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that provides direction to Radix UI components
 * based on the current language direction from LanguageContext
 */
export const DirectionProviderWrapper = ({
  children,
}: DirectionProviderWrapperProps) => {
  const { isRTL } = useLanguage();

  return (
    <DirectionProvider dir={isRTL ? 'rtl' : 'ltr'}>
      {children}
    </DirectionProvider>
  );
};
